import React from 'react';

interface TextButtonProps {
    text: string,
    onClick?: () => void
}

function TextButton(props: TextButtonProps) {
    return <div className="flex justify-center text-center text-sm">
        <button onClick={props.onClick} type="button"
                className="font-medium text-cyan-600 hover:text-cyan-500">
            {props.text}
        </button>
    </div>
}

export default TextButton;